import React, { useEffect, useRef, useState } from "react";
import { contentData, multiplePdfData } from './dummyData';
import ModalComponent from "../../../../../core/common/modal/ModalComponent";
import { ReusableDocumentComponent } from "./ApplianceSpecificationApproval";
import html2pdf from "html2pdf.js";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useGetprintoutPdfDetailsQuery, useLazyGetProjectBinderCoverQuery, useLazyGetProjectCutSheetLabelQuery, useLazyGetTeamMembersEmailQuery, useSendEmailMutation } from "../../../../../services/EndPointsApis";
import { toast } from "react-toastify";
import RichTextEditor from "../../../../../core/common/Rich Text Editor/RichTextEditor";
import { customStyles } from "../../../../../core/common/Custom Style/CustomStyle";
import TextField from "../../../../../core/common/textFields/TextField";
import Select from "react-select";
import MultiplePagePdfSettingClient from "./MultiPage/MultiplePagePdf2";
import MultiplePagePdfPowerOfAttorney from "./MultiPage/MultiplePagePdf";
import MultiplePagePdfCustomCountertop from "./MultiPage/MultiplePagePdf3";
import * as HtmlDocx from "html-docx-js/dist/html-docx";
import CutSheetLables from "../download to pdf/CutSheetLables";
import BinderCover from "../download to pdf/BinderCover";
import ElectricRoutesAckg from "../download to pdf/ElectricRoutesAckg";
import { useReactToPrint } from "react-to-print";
import ImageWithBasePath from "../../../../../core/common/imageWithBasePath";
import AcceptanceOfPlans from "../download to pdf/AcceptanceOfPlans";
import SpecificationGuide from "./MultiPage/SpecificationGuide";
import { exportCustomExcel } from "../../Templates/Excel/CustomExcelSheet";

const PCCAddendaPrintOut = ({ projectId, projectLookups }: any) => {
    const [selectedContentId, setSelectedContentId] = useState<string>('');
    const [modalHeading, setmodalHeading] = useState<string>('');
    const selectedContent = contentData.find((item: any) => item.id === selectedContentId);
    const [showModal, setShowModal] = useState(false);
    const [modalLabelLoading, setIsModalLabelLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const year = new Date().getFullYear();

    const { data: printOutPdfDetails, refetch: refetchPrintOutPdf, isLoading } =
        useGetprintoutPdfDetailsQuery({ ProjectId: projectId });
    const [triggerBinderCover, { data: binderCoverData }] = useLazyGetProjectBinderCoverQuery()
    const [triggerCutSheetLabel, { data: cutSheetLabel }] = useLazyGetProjectCutSheetLabelQuery()

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedContentId('');
    };

    const handleShowModal = (item: any) => {
        setShowModal(true);
        setSelectedContentId(item?.id);
        setmodalHeading(item?.heading);
    };

    const filteredData = contentData.filter((item) =>
        item.heading.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const downloadhandleShowPCCPdf = async ({ selectedContentId }: any) => {
        const content = document.getElementById(selectedContentId);
        const options = {
            margin: 0,
            filename: `Airoom_PCC_${modalHeading}.pdf`,
            html2canvas: { scale: 5 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };
        setIsModalLabelLoading(true);
        try {
            await html2pdf().set(options).from(content).save();
            setShowModal(false);
        } catch (error) {
        } finally {
            setIsModalLabelLoading(false);
        }
    };

    //Email Code 

    //email api
    const [sendEmail, { data, isSuccess }] = useSendEmailMutation();
    //getTeam Member Email
    const [
        triggerTeamsMember,
        { data: getTeamMembers, isSuccess: isSuccessEmail, isFetching },
    ] = useLazyGetTeamMembersEmailQuery();

    const [emails, setEmails] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [fileData, setFileData] = useState<File[]>([]);

    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const decodeHtml = (html: any) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && inputValue.trim()) {
            e.preventDefault();
            const email = inputValue.trim();

            if (
                isValidEmail(email) &&
                !formik.values.ExternalEmailAddresses.includes(email)
            ) {
                formik.setFieldValue("ExternalEmailAddresses", [
                    ...formik.values.ExternalEmailAddresses.filter(
                        (email: string) => email !== ""
                    ),
                    email,
                ]);
                setInputValue("");
            }
        }
    };
    const removeEmail = (email: string) => {
        const filteredEmails = formik.values.ExternalEmailAddresses.filter(
            (e: string) => e !== email
        );
        formik.setFieldValue("ExternalEmailAddresses", filteredEmails);
    };


    const handleSave = () => {
        formik.handleSubmit();
    };
    const handleGetTeamMembers = () => {
        triggerTeamsMember({ projectId: projectId });
    };

    const ValidationSchema = Yup.object().shape({
        Subject: Yup.string().required("Subject is required"),
        Body: Yup.string().required("Message is required"),
        InternalEmailAddresses: Yup.array()
            .of(
                Yup.object().shape({
                    id: Yup.number()
                        .min(1, "Internal User required")
                        .required("Internal User required"),
                })
            )
    });

    const initialValues = {
        Subject: "",
        InternalEmailAddresses: [
            {
                id: 0,
                value: "",
            },
        ],
        ExternalEmailAddresses: [""],
        Body: "",
        Attachments: [] as { name: string; data: ArrayBuffer }[],
    };

    const formik = useFormik({
        initialValues,
        validationSchema: ValidationSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("Subject", values.Subject);
            formData.append(
                "InternalEmailAddresses",
                values.InternalEmailAddresses.map((item) => item.value).toString()
            );
            formData.append(
                "ExternalEmailAddresses",
                values.ExternalEmailAddresses.toString()
            );
            formData.append("Body", values.Body);
            values.Attachments.forEach(({ name, data }, index) => {
                const fileBlob = new Blob([data], { type: "application/pdf" });
                formData.append(`Attachments`, fileBlob, name);
            });
            try {
                await sendEmail(formData).unwrap();
                toast.success("Email Sent successfully");
                formik.resetForm();
                setShowEmailModal(false);
            } catch (error) {
                console.error("Error uploading file:", error);
            }
        },
    });

    const selectValues = formik.values?.InternalEmailAddresses
        ? formik.values.InternalEmailAddresses.filter(
            (users: { id: number; value: string }) =>
                users.id !== 0 && users.value !== ""
        ).map((users: { id: number; value: string }) => ({
            value: users?.id,
            label: users?.value,
        }))
        : [];

    const handleChange = (newValue: any) => {
        const updatedValues = newValue.map(
            (option: { value: any; label: any }) => ({
                id: option.value,
                value: option.label,
            })
        );

        formik.setFieldValue("InternalEmailAddresses", updatedValues);
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const fileArray = Array.from(files);
            setFileData(fileArray);
            formik.setFieldValue("Attachments", fileArray);
        }
    };

    useEffect(() => {
        if (!isFetching && getTeamMembers?.result) {
            console.log(getTeamMembers);

            const mappedMembers = getTeamMembers.result.map((member: any) => ({
                id: member.id,
                value: member.value,
            }));

            setEmails(mappedMembers);
            formik.setFieldValue("InternalEmailAddresses", mappedMembers);
        }
    }, [isFetching, getTeamMembers]);


    const handleGeneratePCCEmailPdf = async (id: any) => {
        const content = document.getElementById(id);
        if (!content) {
            return;
        }

        const options = {
            margin: 0,
            filename: `Airoom_PCC_${modalHeading}.pdf`,
            html2canvas: { scale: 5 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };

        try {
            console.log("Generating PDF...");
            const pdfBlob = await html2pdf()
                .set(options)
                .from(content)
                .toPdf()
                .output("blob");
            // Convert Blob to ArrayBuffer
            const arrayBuffer = await pdfBlob.arrayBuffer();
            // Update Formik field
            formik.setFieldValue("Attachments", [
                { name: `Airoom_PCC_${modalHeading}.pdf`, data: arrayBuffer },
            ]);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };
    const [showEmailModal, setShowEmailModal] = useState(false);

    const handleEmailPCCPdf = (selectedContentId: any) => {
        setmodalHeading(`${modalHeading}`);
        setShowModal(false);
        setShowEmailModal(true);
        handleGeneratePCCEmailPdf(selectedContentId);
    };
    const handleClose = () => {
        setShowEmailModal(false);
        formik.resetForm();
    };

    //multiple page pdf code
    const [showMultiPagePdf1, setShowMultiPagePdf1] = useState(false)
    const [showMultiPagePdf2, setShowMultiPagePdf2] = useState(false)
    const [showMultiPagePdf3, setShowMultiPagePdf3] = useState(false)
    const [modalLabelLoadingMulti1, setmodalLabelLoadingMulti1] = useState(false)
    const [modalLabelLoadingMulti2, setmodalLabelLoadingMulti2] = useState(false)
    const [modalLabelLoadingMulti3, setmodalLabelLoadingMulti3] = useState(false)

    const printRef = useRef(null);

    const handleDownloadMultiplePDF = async () => {

        const content = document.getElementById("21");
        const options = {
            margin: [0, 0],
            filename: "Airoom_PCC_Power of Attorney Authorization.pdf",
            html2canvas: { scale: 5 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all"] }
        };
        setmodalLabelLoadingMulti1(true);
        try {
            await html2pdf().set(options).from(content).save();
            setShowMultiPagePdf1(false);
        } catch (error) {
        } finally {
            setmodalLabelLoadingMulti1(false);
        }
    };

    const handleShowMultiPagePdf1 = (item: any) => {
        setShowMultiPagePdf1(true);
    };
    const handleShowMultiPagePdf2 = (item: any) => {
        setShowMultiPagePdf2(true);
    };
    const handleShowMultiPagePdf3 = (item: any) => {
        setShowMultiPagePdf3(true);
    };
    const handleCloseMultiPage1 = () => {
        setShowMultiPagePdf1(false);
    };
    const handleCloseMultiPage2 = () => {
        setShowMultiPagePdf2(false);
    };
    const handleCloseMultiPage3 = () => {
        setShowMultiPagePdf3(false);
    };

    const handleEmailMultiplePdf = async () => {
        const content = document.getElementById('21');
        if (!content) {
            return;
        }
        const options = {
            margin: [0, 0],
            filename: "Airoom_PCC_Power of Attorney Authorization.pdf",
            html2canvas: { scale: 2 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all"] }
        };

        try {
            console.log("Generating PDF...");
            const pdfBlob = await html2pdf()
                .set(options)
                .from(content)
                .toPdf()
                .output("blob");
            const arrayBuffer = await pdfBlob.arrayBuffer();
            formik.setFieldValue("Attachments", [
                { name: `Airoom_PCC_Power of Attorney Authorization.pdf`, data: arrayBuffer },
            ]);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };

    const handleEmailMultiple = () => {
        setmodalHeading('Power of Attorney Authorization')
        setShowMultiPagePdf1(false);
        setShowEmailModal(true);
        handleEmailMultiplePdf();
    };

    //multipage pdf 2
    const handleDownloadMultiplePDF2 = async () => {

        const content = document.getElementById("22");
        const options = {
            margin: [0, 0],
            filename: "Airoom_PCC_Setting Client Expectations.pdf",
            html2canvas: { scale: 5 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all"] }
        };
        setmodalLabelLoadingMulti2(true);
        try {
            await html2pdf().set(options).from(content).save();
            setShowMultiPagePdf2(false);
        } catch (error) {
        } finally {
            setmodalLabelLoadingMulti2(false);
        }
    };
    const handleEmailMultiplePdf2 = async () => {
        const content = document.getElementById('22');
        if (!content) {
            return;
        }
        const options = {
            margin: [0, 0],
            filename: "Airoom_PCC_Setting Client Expectations.pdf",
            html2canvas: { scale: 2 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all"] }
        };

        try {
            console.log("Generating PDF...");
            const pdfBlob = await html2pdf()
                .set(options)
                .from(content)
                .toPdf()
                .output("blob");
            // Convert Blob to ArrayBuffer
            const arrayBuffer = await pdfBlob.arrayBuffer();
            // Update Formik field
            formik.setFieldValue("Attachments", [
                { name: `Airoom_PCC_Setting Client Expectations.pdf`, data: arrayBuffer },
            ]);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };

    const handleEmailMultiple2 = () => {
        setmodalHeading('Setting Client Expectations')
        setShowMultiPagePdf2(false);
        setShowEmailModal(true);
        handleEmailMultiplePdf2();
    };

    // multipage pdf 3 

    const handleDownloadMultiplePDF3 = async () => {

        const content = document.getElementById("23");
        const options = {
            margin: [0, 0],
            filename: "Airoom_PCC_Custom Countertop Slab Selection Agreement.pdf",
            html2canvas: { scale: 5 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all"] }
        };
        setmodalLabelLoadingMulti3(true);
        try {
            await html2pdf().set(options).from(content).save();
            setShowMultiPagePdf3(false);
        } catch (error) {
        } finally {
            setmodalLabelLoadingMulti3(false);
        }
    };
    const handleEmailMultiplePdf3 = async () => {
        const content = document.getElementById('23');
        if (!content) {
            return;
        }
        const options = {
            margin: [0, 0],
            filename: "Airoom_PCC_Custom Countertop Slab Selection Agreement.pdf",
            html2canvas: { scale: 2 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["avoid-all"] }
        };

        try {
            console.log("Generating PDF...");
            const pdfBlob = await html2pdf()
                .set(options)
                .from(content)
                .toPdf()
                .output("blob");
            // Convert Blob to ArrayBuffer
            const arrayBuffer = await pdfBlob.arrayBuffer();
            // Update Formik field
            formik.setFieldValue("Attachments", [
                { name: `Airoom_PCC_Custom Countertop Slab Selection Agreement.pdf`, data: arrayBuffer },
            ]);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };

    const handleEmailMultiple3 = () => {
        setmodalHeading('Custom Countertop Slab Selection Agreement')
        setShowMultiPagePdf3(false);
        setShowEmailModal(true);
        handleEmailMultiplePdf3();
    };
    //multiple pdf addsing in the searched data 


    //data for binder , cutsheet and electric
    const [showBinderCover, setShowBinderCover] = useState(false);
    const [showCutSheetLabel, setShowCutSheetLabel] = useState(false);
    const [showElectric, setShowElectric] = useState(false);
    const [modalTitlePopup, setModalTitlePopup] = useState("");
    const [isBinderCoverLoading, setIsBinderCoverLoading] = useState(false);
    const [isCutSheetLabelLoading, setIsCutSheetLabelLoading] = useState(false);
    const [isElectricLetterLoading, setIsElectricLetterLoading] = useState(false);

    const handleShowBinderCover = (item: any) => {
        setShowBinderCover(true);
    };
    const handleCloseBinderCover = () => {
        setShowBinderCover(false);
    };

    const handleCloseCutSheetLabel = () => {
        setShowCutSheetLabel(false);
    };
    const handleShowCutSheetLabel = (item: any) => {
        setShowCutSheetLabel(true);
    };

    const handleCloseElectric = () => {
        setShowElectric(false);
    };
    const handleShowElectric = (item: any) => {
        setShowElectric(true);
    };

    const initiateDownloadBinderCover = (blobData: Blob) => {
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Binder Cover.docx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setShowBinderCover(false);
    };
    const downloadhandleShowBinderCover = async () => {
        try {
            const binderCoverData = await triggerBinderCover({ projectId }).unwrap();

            if (!binderCoverData) {
                console.error("No data received for binder cover download.");
                return;
            }
            if (!(binderCoverData instanceof Blob)) {
                console.error("Expected a Blob but received:", binderCoverData);
                return;
            }
            initiateDownloadBinderCover(binderCoverData);

        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };
    const downloadhandleBinderCoverDocx = async () => {
        if (!contentRefBinder.current) {
            alert("No content to export");
            return;
        }
        const htmlContent = contentRefBinder.current.outerHTML;

        try {
            const converted = HtmlDocx.asBlob(htmlContent);

            const url = URL.createObjectURL(converted);
            const link = document.createElement("a");
            link.href = url;
            link.download = "BinderCover.docx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating DOCX:", error);
        }
    };
    const initiateDownloadCutSheet = (blobData: Blob) => {
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Cut Sheet Label.docx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setShowCutSheetLabel(false);
    };

    const downloadhandleShowCutSheetLabel = async () => {
        try {
            const cutSheetData = await triggerCutSheetLabel({ projectId }).unwrap();
            setIsCutSheetLabelLoading(true)

            if (!cutSheetData) {
                console.error("No data received for binder cover download.");
                return;
            }
            if (!(cutSheetData instanceof Blob)) {
                console.error("Expected a Blob but received:", cutSheetData);
                return;
            }

            initiateDownloadCutSheet(cutSheetData);

        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };
    const downloadElectricLetter = async () => {
        const content = document.getElementById("Electric_RoutesAckg");
        const options = {
            margin: 0,
            filename: "ELECTRIC REROUTES ACKNOWLEDGEMENT.pdf",
            html2canvas: { scale: 5 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };
        setIsElectricLetterLoading(true);
        try {
            await html2pdf().set(options).from(content).save();
            setShowElectric(false);
        } catch (error) {
        } finally {
            setIsElectricLetterLoading(false);
        }
    };

    const contentRefBinder = useRef<HTMLDivElement | null>(null);
    const handleGenerateElectric = async () => {
        const content = document.getElementById("Electric_RoutesAckg");
        if (!content) {
            console.error("Element not found:", "Electric_RoutesAckg");
            return;
        }

        const options = {
            margin: 0,
            filename: `ELECTRIC REROUTES ACKNOWLEDGEMENT.pdf`,
            html2canvas: { scale: 5 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };

        try {
            console.log("Generating PDF...");
            const pdfBlob = await html2pdf()
                .set(options)
                .from(content)
                .toPdf()
                .output("blob");
            console.log("PDF Blob created successfully");

            // Convert Blob to ArrayBuffer
            const arrayBuffer = await pdfBlob.arrayBuffer();
            // Update Formik field
            formik.setFieldValue("Attachments", [
                { name: `ELECTRIC REROUTES ACKNOWLEDGEMENT.pdf`, data: arrayBuffer },
            ]);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };

    const handleGenerateBinderCover = async () => {
        const binderCoverData = await triggerBinderCover({ projectId }).unwrap();
        //  Convert Blob to ArrayBuffer
        const arrayBuffer = await binderCoverData.arrayBuffer();
        // Update Formik field
        formik.setFieldValue("Attachments", [
            { name: `Binder Cover.docx`, data: arrayBuffer },
        ]);
    };
    const handleGenerateCutSheetLables = async () => {
        const cutSheetLabelsData = await triggerCutSheetLabel({ projectId }).unwrap();
        //  Convert Blob to ArrayBuffer
        const arrayBuffer = await cutSheetLabelsData.arrayBuffer();
        // Update Formik field
        formik.setFieldValue("Attachments", [
            { name: `Cut Sheet Labels.docx`, data: arrayBuffer },
        ]);
    };

    const handleEmailElectric = () => {
        setModalTitlePopup(`Electric Acknowledgement Email`);
        setShowModal(true);
        setShowElectric(false);
        handleGenerateElectric();
    };

    const handleEmailBinderCover = () => {
        setModalTitlePopup(`Binder Cover Email`);
        setShowModal(true);
        setShowBinderCover(false);
        handleGenerateBinderCover();
    };
    const handleEmailCutSeet = () => {
        setModalTitlePopup(`Cut Sheet Label Email`);
        setShowModal(true);
        setShowCutSheetLabel(false);
        handleGenerateCutSheetLables();
    };
    //direct print code for Power Of attorney
    const [shouldPrintPowerOfAtt, setShouldPrintPowerOfAtt] = useState(false);
    const printRefPowerOfAtt = useRef(null);

    const handlePrintRefPowerOfAtt = useReactToPrint({
        content: () => printRefPowerOfAtt.current,
    });

    const handlePrintPowerOfAtt = () => {
        setShouldPrintPowerOfAtt(true);
        refetchPrintOutPdf();
    };

    const handlePowerOfAtt = () => {
        if (shouldPrintPowerOfAtt) {
            handlePrintRefPowerOfAtt();
            setShouldPrintPowerOfAtt(false);
        }
    };
    //direct print code for Setting Client
    const [shouldPrintSettingClient, setShouldPrintSettingClient] = useState(false);
    const printRefSettingClient = useRef(null);

    const handlePrintRefSettingClient = useReactToPrint({
        content: () => printRefSettingClient.current,
    });

    const handlePrintSettingClient = () => {
        setShouldPrintSettingClient(true);
        refetchPrintOutPdf();
    };

    const handleSettingClient = () => {
        if (shouldPrintSettingClient) {
            handlePrintRefSettingClient();
            setShouldPrintSettingClient(false);
        }
    };
    //direct print code for Counter Top
    const [shouldPrintCounterTop, setShouldPrintCounterTop] = useState(false);
    const printRefCounterTop = useRef(null);

    const handlePrintRefCounterTop = useReactToPrint({
        content: () => printRefCounterTop.current,
    });

    const handlePrintCounterTop = () => {
        setShouldPrintCounterTop(true);
        refetchPrintOutPdf();
    };

    const handleCounterTop = () => {
        if (shouldPrintCounterTop) {
            handlePrintRefCounterTop();
            setShouldPrintCounterTop(false);
        }
    };
    // direct print code for Electric Acknowledge
    const [shouldPrintElectricAcknowledge, setShouldPrintElectricAcknowledge] = useState(false);
    const printRefElectricAcknowledge = useRef(null);

    const handlePrintRefElectricAcknowledge = useReactToPrint({
        content: () => printRefElectricAcknowledge.current,
    });

    const handlePrintElectricAcknowledge = () => {
        setShouldPrintElectricAcknowledge(true);
        refetchPrintOutPdf();
    };

    const handleElectricAcknowledge = () => {
        if (shouldPrintElectricAcknowledge) {
            handlePrintRefElectricAcknowledge();
            setShouldPrintElectricAcknowledge(false);
        }
    };

    // direct print code for Binder Cover
    const [shouldPrintBinderCover, setShouldPrintBinderCover] = useState(false);
    const printRefBinderCover = useRef(null);

    const handlePrintRefBinderCover = useReactToPrint({
        content: () => printRefBinderCover.current,
    });

    const handlePrintBinderCover = () => {
        setShouldPrintBinderCover(true);
        refetchPrintOutPdf();
    };

    const handleBinderCover = () => {
        if (shouldPrintBinderCover) {
            handlePrintRefBinderCover();
            setShouldPrintBinderCover(false);
        }
    };

    // direct print code for Cut Sheet
    const [shouldPrintCutSheet, setShouldPrintCutSheet] = useState(false);
    const printRefCutSheet = useRef(null);

    const handlePrintRefCutSheet = useReactToPrint({
        content: () => printRefCutSheet.current,
    });

    const handlePrintCutSheet = () => {
        setShouldPrintCutSheet(true);
        refetchPrintOutPdf();
    };

    const handleCutSheet = () => {
        if (shouldPrintCutSheet) {
            handlePrintRefCutSheet();
            setShouldPrintCutSheet(false);
        }
    };
    //acceptance of plans
    const [isAcceptancePlansLetterLoading, setIsAcceptancePlansLetterLoading] = useState(false);
    const [showAcceptancePlans, setShowAcceptancPlans] = useState(false);
    const handleCloseAcceptancPlans = () => {
        setShowAcceptancPlans(false);
    };
    const handleShowAcceptancPlans = (item: any) => {
        setShowAcceptancPlans(true);
    };
    const handleGenerateAccptanceOfPlans = async () => {
        const content = document.getElementById("AcceptanceOfPlans");
        if (!content) {
            console.error("Element not found:", "AcceptanceOfPlans");
            return;
        }

        const options = {
            margin: 0,
            filename: `Acceptance Of Plans.pdf`,
            html2canvas: { scale: 5 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };

        try {
            console.log("Generating PDF...");
            const pdfBlob = await html2pdf()
                .set(options)
                .from(content)
                .toPdf()
                .output("blob");
            console.log("PDF Blob created successfully");

            // Convert Blob to ArrayBuffer
            const arrayBuffer = await pdfBlob.arrayBuffer();
            // Update Formik field
            formik.setFieldValue("Attachments", [
                { name: `Acceptance Of Plans.pdf`, data: arrayBuffer },
            ]);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };
    const handleEmailAcceptanceOfPlans = () => {
        setModalTitlePopup(`Acceptance Of Plans Email`);
        setShowModal(true);
        setShowAcceptancPlans(false);
        handleGenerateAccptanceOfPlans();
    };
    const downloadAcceptanceOfPlansLetter = async () => {
        const content = document.getElementById("AcceptanceOfPlans");
        const options = {
            margin: 0,
            filename: "Acceptance Of Plans.pdf",
            html2canvas: { scale: 5 },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        };
        setIsAcceptancePlansLetterLoading(true);
        try {
            await html2pdf().set(options).from(content).save();
            setShowAcceptancPlans(false);
        } catch (error) {
        } finally {
            setIsAcceptancePlansLetterLoading(false);
        }
    };
    //print acceptance of plans

    const [shouldPrintAccp, setShouldPrintAccp] = useState(false);
    const printRefAccp = useRef(null);

    const handlePrintAccp = useReactToPrint({
        content: () => printRefAccp.current,
    });

    const handlePrintAccep = () => {
        setShouldPrintAccp(true);
        refetchPrintOutPdf();
    };

    const handleAccpReady = () => {
        if (shouldPrintAccp) {
            handlePrintAccp();
            setShouldPrintAccp(false);
        }
    };
    //print Specification Guide
    const [shouldPrintSpecificationGuide, setShouldPrintSpecificationGuide] = useState(false);
    const printRefSpecificationGuide = useRef(null);

    const handlePrintRefSpecificationGuide = useReactToPrint({
        content: () => printRefSpecificationGuide.current,
    });

    const handlePrintSpecificationGuide = () => {
        setShouldPrintSpecificationGuide(true);
    };

    const handleSpecificationGuide = () => {
        if (shouldPrintSpecificationGuide) {
            handlePrintRefSpecificationGuide();
            setShouldPrintSpecificationGuide(false);
        }
    };


    // for dynamic data print


    const [isRenderReady, setIsRenderReady] = useState(false);
    const [shouldPrint, setShouldPrint] = useState(false);
    const [pccPrintIdForPdf, setPccPrintIdForPdf] = useState(null);

    const printRefDynamic = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        content: () => printRefDynamic.current,
    } as any);



    const handlePrintWithData = (item: any) => {
        setPccPrintIdForPdf(item);
        setShouldPrint(true);
        setIsRenderReady(false);
        refetchPrintOutPdf();
        setSelectedContentId(item?.id);
        setmodalHeading(item?.heading);
    };

    const handleDynamicPdf = () => {
        if (shouldPrint && printOutPdfDetails) {
            handlePrint();
            setShouldPrint(false);
        }
    };

    //Multi print dynamic 
    const [selectedRecords, setSelectedRecords] = useState<any[]>([]);
    const [pdfLoading, setPdfIsLoading] = useState(false);

    const handleCheck = (record: any) => {
        setSelectedRecords(prev =>
            prev.includes(record)
                ? prev.filter(r => r !== record)
                : [...prev, record]
        );
    };

    const handleSelectAll = (records: any[]) => {
        if (selectedRecords.length === records.length) {
            setSelectedRecords([]);
        } else {
            setSelectedRecords([...records]);
        }
    };

    // const downloadPDFMulti = async () => {
    //     setPdfIsLoading(true);
    //     const content = document.getElementById("pdf-multi-container");
    //     if (!content) return;
    //     refetchPrintOutPdf()
    //     const options = {
    //         margin: 0,
    //         filename: "MultiRecord.pdf",
    //         html2canvas: { scale: 5 },
    //         jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    //     };

    //     try {
    //         const pdf = html2pdf().set(options).from(content);
    //         // Instead of save(), generate a blob URL
    //         const blobUrl = await pdf.output('bloburl');
    //         // Open in new window
    //         window.open(blobUrl, "_blank");
    //     } catch (err) {
    //         console.error(err);
    //     } finally {
    //         setPdfIsLoading(false);
    //         setSelectedRecords([]);
    //     }
    // };

    const printRefMultiDynamic = useRef<HTMLDivElement>(null);
    const downloadPDFMultiDynamic = useReactToPrint({
        content: () => printRefMultiDynamic.current,
        documentTitle: "multi-component",
        onBeforeGetContent: async () => {
            setPdfIsLoading(true);
            await refetchPrintOutPdf();
        },
        onAfterPrint: () => {
            setPdfIsLoading(false);
            setSelectedRecords([]);
        },
    });

    const handleDownloadPDFMultiDynamic = () => {
        if (!printRefMultiDynamic.current) return;
        if (selectedRecords.length === 0) return;
        downloadPDFMultiDynamic();
    };

    //multi print static

    const [selectedDocs, setSelectedDocs] = useState<string[]>([]);
    const [isPrinting, setIsPrinting] = useState(false);

    const handleCheckStatic = (name: string) => {
        setSelectedDocs(prev =>
            prev.includes(name) ? prev.filter(item => item !== name) : [...prev, name]
        );
    };
    const allDocs = [
        "power",
        "setting",
        "counterTop",
        "electric",
        "accept",
        "binder",
        "cutSheet"
    ];

    const handleSelectAllstatic = () => {
        if (selectedDocs.length === allDocs.length) {
            setSelectedDocs([]);
        } else {
            setSelectedDocs(allDocs);
        }
    };
    const printRefMultiStatic = useRef<HTMLDivElement>(null);
    const downloadPDFMultiStatic = useReactToPrint({
        content: () => printRefMultiStatic.current,
        documentTitle: "multi-component",
        onBeforeGetContent: async () => {
            setIsPrinting(true);
            await refetchPrintOutPdf();
        },
        onAfterPrint: () => {
            setIsPrinting(false);
            setSelectedDocs([]);
        },
    });

    const handleDownloadPDFMultiStatic = () => {
        if (!printRefMultiStatic.current) return;
        if (selectedDocs.length === 0) return;
        downloadPDFMultiStatic();
    };

    const userInfo = {
        title:'Architectural Plan Development change Record',
        name: "John Doe",
        address: "123 Main St, Chicago",
        phone: "(312) 555-1234",
    };

    const tableData = [
        { Project: "Alpha", Status: "Closed", Budget: 120000, Date: "2025-08-20" },
        { Project: "Beta", Status: "Open", Budget: 90000, Date: "2025-08-21" },
        { Project: "Gamma", Status: "In Progress", Budget: 150000, Date: "2025-08-22" },
    ];
    const file = new File([""], "airoomlogo.png", { type: "image/png" });

    return (
        <div className="p-4" >
            <div className="mb-4">
                <div className="row">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body card-css">
                                <h6>
                                    The Link Below represents printouts available in different
                                    places in AFD. Use this page to quickly locate and print
                                    printouts of all kinds.
                                </h6>
                                {/* <div>
                                    <button
                                        onClick={() => exportCustomExcel(userInfo,tableData)}
                                        className="px-4 py-2 bg-blue-600 text-white rounded"
                                    >
                                        Export Styled Excel
                                    </button>
                                </div> */}
                                {selectedRecords.length > 0 && (
                                    <div className="d-flex align-items-center justify-content-end mt-3">
                                        <button className="btn btn-primary" onClick={handleDownloadPDFMultiDynamic} disabled={selectedRecords.length > 11}>
                                            {pdfLoading ? "Printing....." : "Print"}
                                        </button>
                                    </div>
                                )}
                                {selectedRecords.length > 11 &&
                                    <p className="color-red">
                                        You can only print a maximum of 11 documents at a time.
                                    </p>
                                }
                                <input
                                    type="text"
                                    className="form-control my-3"
                                    placeholder="Search..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <div className="table-responsive mt-3" style={{ maxHeight: '43vh' }}>
                                    <table className="table datanew dataTable no-footer table-hover">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Name</th>
                                                <th>TYPE</th>
                                                <th>Print</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* {filteredData.length > 0 ? ( */}
                                            {filteredData.map((item) => (
                                                <React.Fragment key={item.id}>
                                                    <tr>
                                                        <td>
                                                            <label className="checkboxs mb-3">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedRecords.includes(item)}
                                                                    onChange={() => handleCheck(item)}
                                                                    className="cursor-pointer"
                                                                />
                                                                <span className="checkmarks" />
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className="color-red cursor-pointer text-decoration-underline"
                                                                onClick={() => handleShowModal(item)}
                                                            >
                                                                {item.heading}
                                                            </div>
                                                        </td>
                                                        <td>Project</td>
                                                        <td
                                                            className="cursor-pointer"
                                                            // onClick={() => handleShowAddenda(data)}
                                                            onClick={() => handlePrintWithData(item)}
                                                        >
                                                            {!isLoading ?
                                                                <button
                                                                    className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                                    data-tooltip-id="my-tooltip-5">
                                                                    <ImageWithBasePath
                                                                        src="assets/img/printIcon.svg"
                                                                        className=""
                                                                        alt="Logo"
                                                                        width={16}
                                                                        height={16}
                                                                    />
                                                                </button>
                                                                :
                                                                <div className="spinnerPdf" />
                                                            }

                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ))
                                            }

                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3">
                            <div className="card-body card-css">
                                {selectedDocs.length > 0 && (
                                    <div className="d-flex align-items-center justify-content-end mt-3">
                                        <button className="btn btn-primary" onClick={handleDownloadPDFMultiStatic}>
                                            {isPrinting ? "Printing....." : "Print"}
                                        </button>
                                    </div>
                                )}
                                <div className="table-responsive mt-3" style={{ maxHeight: '43vh' }}>
                                    <table className="table datanew dataTable no-footer table-hover">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.length === allDocs.length}
                                                            onChange={handleSelectAllstatic}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </th>
                                                <th>Name</th>
                                                <th>TYPE</th>
                                                <th>Print</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>

                                                </td>
                                                <td>
                                                    <div
                                                        className="color-red cursor-pointer text-decoration-underline"
                                                    >
                                                        Specification Guide 08{year}
                                                    </div>
                                                </td>
                                                <td>Project</td>
                                                <td className="cursor-pointer"
                                                    onClick={handlePrintSpecificationGuide}>
                                                    {!shouldPrintSpecificationGuide ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.includes("power")}
                                                            onChange={() => handleCheckStatic("power")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </td>
                                                <td>
                                                    <div
                                                        className="color-red cursor-pointer text-decoration-underline"
                                                        onClick={handleShowMultiPagePdf1}
                                                    >
                                                        Power of Attorney Authorization
                                                    </div>
                                                </td>
                                                <td>Project</td>
                                                <td className="cursor-pointer"
                                                    onClick={handlePrintPowerOfAtt}>
                                                    {!shouldPrintPowerOfAtt ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.includes("setting")}
                                                            onChange={() => handleCheckStatic("setting")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </td>
                                                <td>
                                                    <div
                                                        className="color-red cursor-pointer text-decoration-underline"
                                                        onClick={handleShowMultiPagePdf2}
                                                    >
                                                        Setting Client Expectations
                                                    </div>
                                                </td>
                                                <td>Project</td>
                                                <td className="cursor-pointer"
                                                    onClick={handlePrintSettingClient}>
                                                    {!shouldPrintSettingClient ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.includes("counterTop")}
                                                            onChange={() => handleCheckStatic("counterTop")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </td>
                                                <td>
                                                    <div
                                                        className="color-red cursor-pointer text-decoration-underline"
                                                        onClick={handleShowMultiPagePdf3}
                                                    >
                                                        Custom Countertop Slab Selection Agreement
                                                    </div>
                                                </td>
                                                <td>Project</td>
                                                <td className="cursor-pointer"
                                                    onClick={handlePrintCounterTop}>
                                                    {!shouldPrintCounterTop ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.includes("electric")}
                                                            onChange={() => handleCheckStatic("electric")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </td>
                                                <td
                                                    className="text-decoration-underline color-red cursor-pointer mb-0"
                                                    onClick={handleShowElectric}
                                                >
                                                    Electric Acknowledgement
                                                </td>
                                                <td>Lead</td>
                                                <td className="cursor-pointer"
                                                    onClick={handlePrintElectricAcknowledge}>
                                                    {!shouldPrintElectricAcknowledge ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.includes("accept")}
                                                            onChange={() => handleCheckStatic("accept")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </td>
                                                <td
                                                    className="text-decoration-underline color-red cursor-pointer mb-0"
                                                    onClick={handleShowAcceptancPlans}
                                                >
                                                    Acceptance Of Plans V1
                                                </td>
                                                <td>Lead</td>
                                                <td
                                                    className="cursor-pointer"
                                                    onClick={handlePrintAccep}
                                                >
                                                    {!shouldPrintAccp ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.includes("binder")}
                                                            onChange={() => handleCheckStatic("binder")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </td>
                                                <td
                                                    className="text-decoration-underline color-red cursor-pointer mb-0"
                                                    onClick={handleShowBinderCover}
                                                >
                                                    Binder Cover
                                                </td>
                                                <td>Lead</td>
                                                <td className="cursor-pointer"
                                                    onClick={handlePrintBinderCover}>
                                                    {!shouldPrintBinderCover ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <label className="checkboxs mb-3">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDocs.includes("cutSheet")}
                                                            onChange={() => handleCheckStatic("cutSheet")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </td>
                                                <td
                                                    className="text-decoration-underline color-red cursor-pointer mb-0"
                                                    onClick={() => downloadhandleShowCutSheetLabel()}
                                                >
                                                    Cut Sheet Label
                                                </td>
                                                <td>Lead</td>
                                                <td className="cursor-pointer"
                                                    onClick={handlePrintCutSheet}>
                                                    {!shouldPrintCutSheet ?
                                                        <button
                                                            className="cursor-pointer border-0 pt-2 p-0 bg-transparent"
                                                            data-tooltip-id="my-tooltip-5">
                                                            <ImageWithBasePath
                                                                src="assets/img/printIcon.svg"
                                                                className=""
                                                                alt="Logo"
                                                                width={16}
                                                                height={16}
                                                            />
                                                        </button>
                                                        :
                                                        <div className="spinnerPdf" />
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {printOutPdfDetails?.result &&
                <div style={{ position: 'absolute', left: '-9999px', top: 0, overflow: 'hidden' }}>
                    <div id="pdf-multi-container" ref={printRefMultiDynamic}>
                        {selectedRecords.map(record => (
                            <ReusableDocumentComponent
                                key={record.id}
                                clientName={printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                                address={printOutPdfDetails?.result?.propertyAddressLine1}
                                cityStateZip={
                                    `${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''}${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''}${printOutPdfDetails?.result?.propertyZipCode || ''}`
                                }

                                projectNumber={printOutPdfDetails?.result?.projectNumber}
                                heading={record?.heading}
                                bodyContent={record?.bodyContent}
                                selectedContentId={record?.id}
                                footerContent={record?.footerContent}
                                logoSrc={record?.logoSrc}
                                footer2={record?.footer2}
                            />
                        ))}
                    </div>
                </div>
            }
            <ModalComponent
                modalTitle={modalHeading}
                isVisible={showModal}
                cancelButton="Close"
                onClose={handleCloseModal}
                buttonText2="Send Email"
                saveButton={modalLabelLoading ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandleShowPCCPdf({ selectedContentId })}
                onSave2={() => handleEmailPCCPdf(selectedContentId)}
            >
                {selectedContent ? (
                    <ReusableDocumentComponent

                        clientName={printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                        address={printOutPdfDetails?.result?.propertyAddressLine1}
                        cityStateZip={
                            `${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''}${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''}${printOutPdfDetails?.result?.propertyZipCode || ''}`
                        }

                        projectNumber={printOutPdfDetails?.result?.projectNumber}
                        heading={selectedContent?.heading}
                        bodyContent={selectedContent?.bodyContent}
                        selectedContentId={selectedContentId}
                        footerContent={selectedContent?.footerContent}
                        logoSrc={selectedContent?.logoSrc}
                        footer2={selectedContent?.footer2}
                    />
                ) : (
                    <p>No content selected.</p>
                )}
            </ModalComponent>
            <div
                ref={printRefDynamic}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrint && (
                    <ReusableDocumentComponent
                        clientName={printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                        address={printOutPdfDetails?.result?.propertyAddressLine1}
                        cityStateZip={
                            `${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''}${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''}${printOutPdfDetails?.result?.propertyZipCode || ''}`
                        }
                        printRef={printRefDynamic}
                        projectNumber={printOutPdfDetails?.result?.projectNumber}
                        heading={selectedContent?.heading}
                        bodyContent={selectedContent?.bodyContent}
                        selectedContentId={selectedContentId}
                        footerContent={selectedContent?.footerContent}
                        logoSrc={selectedContent?.logoSrc}
                        onRenderReady={handleDynamicPdf}
                    />
                )}
            </div>
            {/* MultiPagePdf1  */}
            <ModalComponent
                modalTitle='Power of Attorney Authorization'
                isVisible={showMultiPagePdf1}
                cancelButton="Close"
                onClose={handleCloseMultiPage1}
                buttonText2="Send Email"
                saveButton={modalLabelLoadingMulti1 ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={handleDownloadMultiplePDF}
                onSave2={handleEmailMultiple}
            >
                <MultiplePagePdfPowerOfAttorney printRef={printRef} printOutPdfDetails={printOutPdfDetails} />
            </ModalComponent>
            <div
                ref={printRefPowerOfAtt}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintPowerOfAtt && (
                    <MultiplePagePdfPowerOfAttorney printRef={printRefPowerOfAtt} printOutPdfDetails={printOutPdfDetails}
                        onRenderReady={handlePowerOfAtt}
                    />
                )}
            </div>
            {/* MultiPage Pdf 2  */}
            <ModalComponent
                modalTitle='Setting Client Expectations'
                isVisible={showMultiPagePdf2}
                cancelButton="Close"
                onClose={handleCloseMultiPage2}
                buttonText2="Send Email"
                saveButton={modalLabelLoadingMulti2 ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={handleDownloadMultiplePDF2}
                onSave2={handleEmailMultiple2}
            >
                <MultiplePagePdfSettingClient printRef={printRef} printOutPdfDetails={printOutPdfDetails} />
            </ModalComponent>
            <div
                ref={printRefSettingClient}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintSettingClient && (
                    <MultiplePagePdfSettingClient printRef={printRefSettingClient} printOutPdfDetails={printOutPdfDetails}
                        onRenderReady={handleSettingClient}
                    />
                )}
            </div>
            {/* Multipage pdf 3  */}
            <ModalComponent
                modalTitle='Custom Countertop Slab Selection Agreement'
                isVisible={showMultiPagePdf3}
                cancelButton="Close"
                onClose={handleCloseMultiPage3}
                buttonText2="Send Email"
                saveButton={modalLabelLoadingMulti3 ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={handleDownloadMultiplePDF3}
                onSave2={handleEmailMultiple3}
            >
                <MultiplePagePdfCustomCountertop printRef={printRef} printOutPdfDetails={printOutPdfDetails} />
            </ModalComponent>
            <div
                ref={printRefCounterTop}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintCounterTop && (
                    <MultiplePagePdfCustomCountertop printRef={printRefCounterTop} printOutPdfDetails={printOutPdfDetails}
                        onRenderReady={handleCounterTop}
                    />
                )}
            </div>
            {/* //print specification guide */}

            <div
                ref={printRefSpecificationGuide}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {shouldPrintSpecificationGuide && (
                    <SpecificationGuide printRef={printRefSpecificationGuide}
                        onRenderReady={handleSpecificationGuide}
                    />
                )}
            </div>
            {/* Email Pdf  */}
            <ModalComponent
                buttonText="Send"
                modalTitle={modalHeading}
                onClose={handleClose}
                onSave={handleSave}
                isVisible={showEmailModal}
                cancelButton="Cancel"
                saveButton="Send"
            >
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="input-label">
                                <TextField
                                    label="Subject"
                                    required
                                    type="text"
                                    {...formik.getFieldProps("Subject")}
                                />
                            </div>
                            {formik.touched.Subject && formik.errors.Subject && (
                                <>
                                    <div className="error">{formik.errors.Subject}</div>
                                </>
                            )}
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Internal Users</label>
                                    <button
                                        className="btn btn-primary mb-1 mt-1 fs-11"
                                        onClick={handleGetTeamMembers}
                                    >
                                        Get Team Members
                                    </button>
                                </div>
                                <Select
                                    isMulti={true}
                                    styles={customStyles}
                                    className="select multi-select"
                                    options={
                                        projectLookups?.result?.ActiveUserEmail?.map(
                                            (option: any) => ({
                                                label: option?.value,
                                                value: option?.id,
                                            })
                                        ) || []
                                    }
                                    value={selectValues}
                                    onChange={(newValue: any) => handleChange(newValue)}
                                />
                            </div>
                            {Array.isArray(formik.errors.InternalEmailAddresses) &&
                                formik.errors.InternalEmailAddresses.map((error, index) => {
                                    const fieldTouched =
                                        formik.touched.InternalEmailAddresses?.[index];
                                    const isObjectError =
                                        typeof error === "object" && error !== null;

                                    return (
                                        <div key={index}>
                                            {isObjectError && fieldTouched?.id && error.id && (
                                                <div className="error">{error.id}</div>
                                            )}
                                            {isObjectError && fieldTouched?.value && error.value && (
                                                <div className="error">{error.value}</div>
                                            )}
                                        </div>
                                    );
                                })}
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between">
                                    <label className="input-label">External Users</label>
                                </div>
                                <div className="email-input-container">
                                    <div className="badges-container">
                                        {formik.values.ExternalEmailAddresses[0] !== "" ? (
                                            formik.values.ExternalEmailAddresses.map(
                                                (email: string, index: number) => (
                                                    <span
                                                        key={index}
                                                        className="badge badge-pill badge-primary me-2"
                                                    >
                                                        {email}{" "}
                                                        <button
                                                            type="button"
                                                            className="btn-close ms-1"
                                                            onClick={() => removeEmail(email)}
                                                        >
                                                            &times;
                                                        </button>
                                                    </span>
                                                )
                                            )
                                        ) : (
                                            <span className="text-muted"></span>
                                        )}
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter email and Press enter"
                                            value={inputValue}
                                            onChange={(e) => setInputValue(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </div>
                                    {formik.errors.ExternalEmailAddresses && (
                                        <div className="text-danger">
                                            {formik.errors.ExternalEmailAddresses}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <RichTextEditor
                                    value={formik.values.Body}
                                    name="Message"
                                    required={true}
                                    onChange={(value: any) => formik.setFieldValue("Body", value)}
                                />
                            </div>
                            {formik.touched.Body && formik.errors.Body && (
                                <>
                                    <div className="error">{formik.errors.Body}</div>
                                </>
                            )}
                            {/* <div className='col-md-12'>
                            <div className='d-flex flex-column'>
                              <label className='input-label'> Attachments</label>
                              <input type="file" className=''
                                onChange={(event) => {
                                  const file = event.currentTarget.files?.[0];
                                  if (file) {
                                    file.arrayBuffer().then((arrayBuffer) => {
                                      formik.setFieldValue("Attachments", [{ name: file.name, data: arrayBuffer }]);
                                    });
                                  }
                                }}
                                id="file"
                                name="file"
                                accept=".png, .jpg, .jpeg, .pdf"
                              />
                              {formik.values.Attachments.length > 0 && (
                                <p>Selected File: {formik.values.Attachments[0].name}</p>
                              )}
                            </div>
                          </div> */}
                            <label className="input-label mt-2"> Attachments</label>
                            <div className="br-gray p-2 bg-lightGray">
                                <p>{formik.values.Attachments[0]?.name}</p>
                            </div>
                        </div>
                    </div>
                </>
            </ModalComponent>

            {/* binder cover , cut sheet and electric modal */}

            <ModalComponent
                modalTitle="Electric Acknowledgement"
                isVisible={showElectric}
                cancelButton="Close"
                onClose={handleCloseElectric}
                buttonText2="Send Email"
                onSave2={handleEmailElectric}
                saveButton={isElectricLetterLoading ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={() => downloadElectricLetter()}
            >
                <ElectricRoutesAckg printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefElectricAcknowledge}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintElectricAcknowledge && (
                    <ElectricRoutesAckg printRef={printRefElectricAcknowledge} printOutPdfDetails={printOutPdfDetails?.result}
                        onRenderReady={handleElectricAcknowledge}
                    />
                )}
            </div>
            <ModalComponent
                modalTitle="Binder Cover"
                isVisible={showBinderCover}
                cancelButton="Close"
                onClose={handleCloseBinderCover}
                buttonText2="Send Email"
                onSave2={handleEmailBinderCover}
                saveButton={isBinderCoverLoading ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandleShowBinderCover()}
            >
                <BinderCover printOutPdfDetails={printOutPdfDetails?.result} printRef={contentRefBinder} />
            </ModalComponent>
            <div
                ref={printRefBinderCover}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintBinderCover && (
                    <BinderCover printRef={printRefBinderCover} printOutPdfDetails={printOutPdfDetails?.result}
                        onRenderReady={handleBinderCover}
                    />
                )}
            </div>
            <ModalComponent
                modalTitle="Cut Sheet Label"
                isVisible={showCutSheetLabel}
                cancelButton="Close"
                onClose={handleCloseCutSheetLabel}
                buttonText2="Send Email"
                onSave2={handleEmailCutSeet}
                saveButton={isCutSheetLabelLoading ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={() => downloadhandleShowCutSheetLabel()}
            >
                <CutSheetLables printOutPdfDetails={printOutPdfDetails?.result} printRef={contentRefBinder} />
            </ModalComponent>
            <div
                ref={printRefCutSheet}
                className="job-card-print"
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails && shouldPrintCutSheet && (
                    <CutSheetLables printRef={printRefCutSheet} printOutPdfDetails={printOutPdfDetails?.result}
                        onRenderReady={handleCutSheet}
                    />
                )}
            </div>
            <ModalComponent
                modalTitle="Acceptance Of Plans"
                isVisible={showAcceptancePlans}
                cancelButton="Close"
                onClose={handleCloseAcceptancPlans}
                buttonText2="Send Email"
                onSave2={handleEmailAcceptanceOfPlans}
                saveButton={isAcceptancePlansLetterLoading ? "Downloading..." : "Download"}
                className="p-2 modal-xl"
                onSave={() => downloadAcceptanceOfPlansLetter()}
            >
                <AcceptanceOfPlans printOutPdfDetails={printOutPdfDetails?.result} />
            </ModalComponent>
            <div
                ref={printRefAccp}
                style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }}
            >
                {printOutPdfDetails?.result && shouldPrintAccp && (
                    <AcceptanceOfPlans printOutPdfDetails={printOutPdfDetails?.result} onRenderReady={handleAccpReady} targetRef={printRefAccp} />
                )}
            </div>
            {/* multi static print data  */}
            {
                printOutPdfDetails?.result &&
                <div style={{ position: 'absolute', left: '-9999px', top: 0, height: 0, overflow: 'hidden' }} >
                    <div id="pdf-multi-Static" ref={printRefMultiStatic}>
                        {selectedDocs.includes("power") && <MultiplePagePdfPowerOfAttorney printOutPdfDetails={printOutPdfDetails} />}
                        {selectedDocs.includes("setting") && <MultiplePagePdfSettingClient printOutPdfDetails={printOutPdfDetails} />}
                        {selectedDocs.includes("counterTop") && <MultiplePagePdfCustomCountertop printOutPdfDetails={printOutPdfDetails} />}
                        {selectedDocs.includes("electric") && <ElectricRoutesAckg printOutPdfDetails={printOutPdfDetails?.result} />}
                        {selectedDocs.includes("accept") && <AcceptanceOfPlans printOutPdfDetails={printOutPdfDetails?.result} />}
                        {selectedDocs.includes("binder") && <BinderCover printOutPdfDetails={printOutPdfDetails?.result} />}
                        {selectedDocs.includes("cutSheet") && <CutSheetLables printOutPdfDetails={printOutPdfDetails?.result} />}
                    </div>
                </div>
            }
        </div >
    );
};

export default PCCAddendaPrintOut;
